export default {
      id: "arrow-point-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-point-usage",
      toString: function () {
        return this.url;
      }
    }